"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactI18next = require("react-i18next");
var _APVerticalScroller = _interopRequireDefault(require("../common/APVerticalScroller/APVerticalScroller"));
var _BulkCancelButtonsComponent = _interopRequireDefault(require("./BulkCancelButtonsComponent/BulkCancelButtonsComponent"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _browserHelper = require("../../helpers/browserHelper");
var _Level2DataTableComponent = _interopRequireDefault(require("./Level2DataTableComponent"));
var _PriceGroupingSelector = _interopRequireDefault(require("./PriceGroupingSelector/PriceGroupingSelector"));
var _priceGroupingHelper = require("../../helpers/orderBook/priceGroupingHelper");
var _decimalPlacesHelper = require("../../helpers/decimalPlaces/decimalPlacesHelper");
require("../../styles/components/TradeComponent.css");
require("./OrderBookComponent.css");
var _APIcon = _interopRequireDefault(require("../../components/common/APIcon"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var tradeComponentClasses = (0, _cssClassesHelper.getBEMClasses)('trade-component');
var orderBookClasses = (0, _cssClassesHelper.getBEMClasses)('orderbook');
var flexTable = (0, _cssClassesHelper.getBEMClasses)('flex-table');
var OrderBookComponent = /*#__PURE__*/function (_React$Component) {
  function OrderBookComponent(props) {
    var _this;
    _classCallCheck(this, OrderBookComponent);
    _this = _callSuper(this, OrderBookComponent, [props]);
    // default state
    _defineProperty(_this, "resizeEventListener", function () {
      return _this.onClickCenter(true);
    });
    // When returning to a backgrounded tab, force a clean recenter. While the tab
    // was hidden, scroll measurements are unreliable and a stray re-pin could have
    // latched the scrollers off their rest position (see APVerticalScroller.scrollToRest).
    _defineProperty(_this, "visibilityChangeListener", function () {
      if (!document.hidden) _this.onClickCenter(true);
    });
    _this.state = {
      showCenterButton: false,
      //  will change to true when user scrolls away from rest position
      viewMode: localStorage.getItem('orderBookViewMode') || 'both',
      grouping: _this.resolveGrouping(props.selectedInstrumentId)
    };
    // event handler bindings
    _this.onClickCenter = _this.onClickCenter.bind(_this);
    _this.resizeEventListener = _this.resizeEventListener.bind(_this);
    _this.onScrollRestChange = _this.onScrollRestChange.bind(_this);
    _this.handleScrollRestChange = _this.handleScrollRestChange.bind(_this);
    _this.onGroupingChange = _this.onGroupingChange.bind(_this);
    _this.buyScroller = /*#__PURE__*/_react["default"].createRef();
    _this.sellScroller = /*#__PURE__*/_react["default"].createRef();
    _this.groupDataCache = {};
    return _this;
  }

  // No instrument-derived default: forcing e.g. 0.01 grouping on a sub-cent instrument
  // would collapse its whole book into a single Price: 0 row, so grouping starts unset
  // (dropdown shows its placeholder) unless the user already picked something for this
  // instrument.
  _inherits(OrderBookComponent, _React$Component);
  return _createClass(OrderBookComponent, [{
    key: "resolveGrouping",
    value: function resolveGrouping(selectedInstrumentId) {
      return (0, _priceGroupingHelper.getStoredGrouping)(selectedInstrumentId, this.getGroupingOptions());
    }

    // getPriceGroupingOptions returns a fresh options array/objects on every call. render()
    // calls this every websocket tick, and PriceGroupingSelector's options prop feeds into
    // its React.memo comparison - a new array reference each render defeats that memo (the
    // menu flashes closed mid-interaction), so the result is cached per translation function.
  }, {
    key: "getGroupingOptions",
    value: function getGroupingOptions() {
      var t = this.props.t;
      if (!this.groupingOptionsCache || this.groupingOptionsCache.t !== t) {
        this.groupingOptionsCache = {
          t: t,
          options: (0, _priceGroupingHelper.getPriceGroupingOptions)(t)
        };
      }
      return this.groupingOptionsCache.options;
    }
  }, {
    key: "memoizedGroupLevel2Data",
    value: function memoizedGroupLevel2Data(side, data, grouping) {
      var cached = this.groupDataCache[side];
      if (cached && cached.data === data && cached.grouping === grouping) {
        return cached.result;
      }
      var result = (0, _priceGroupingHelper.groupLevel2Data)(data, grouping, side);
      this.groupDataCache[side] = {
        data: data,
        grouping: grouping,
        result: result
      };
      return result;
    }
  }, {
    key: "onClickCenter",
    value: function onClickCenter() {
      var _this2 = this;
      var overrideUserScrolled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.sellScroller.current && this.buyScroller.current) {
        var scrollToRest = function scrollToRest() {
          _this2.sellScroller.current.scrollToRest();
          _this2.buyScroller.current.scrollToRest();
        };
        if (overrideUserScrolled) return this.sellScroller.current.resetUserScrolled(function () {
          return _this2.buyScroller.current.resetUserScrolled(scrollToRest);
        });
        scrollToRest();
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var instrumentChanged = this.props.selectedInstrumentId !== prevProps.selectedInstrumentId;

      // Switching instruments resets the selector to unset rather than restoring the grouping
      // stored for the newly selected instrument - carrying a selection over silently
      // (e.g. BTCUSD's "10" appearing on ETHUSD) read as a bug in QA.
      //
      // The first undefined -> id transition is not a user switch, so it restores instead:
      // TradingLayout renders the order book unconditionally, so on a cold load this component
      // mounts before an instrument is selected and the constructor's resolveGrouping can only
      // read the useless `orderBookGrouping:undefined` key. That transition is what actually
      // performs the restore of the per-instrument value written by onGroupingChange, e.g.
      // after a page reload on that instrument.
      if (instrumentChanged) {
        this.setState({
          grouping: prevProps.selectedInstrumentId === undefined ? this.resolveGrouping(this.props.selectedInstrumentId) : undefined
        });
      }
      this.onClickCenter(instrumentChanged);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener('resize', this.resizeEventListener);
      document.addEventListener('visibilitychange', this.visibilityChangeListener);
      this.onClickCenter();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeEventListener);
      document.removeEventListener('visibilitychange', this.visibilityChangeListener);
    }
  }, {
    key: "onScrollRestChange",
    value: function onScrollRestChange() {
      // show "center" button when user scrolls away from rest position
      setTimeout(this.handleScrollRestChange, 230);
    }
  }, {
    key: "handleScrollRestChange",
    value: function handleScrollRestChange() {
      if (this.sellScroller.current) {
        var sellIsAtRest = this.sellScroller.current.getIsAtRest();
        var buyIsAtRest = this.buyScroller.current.getIsAtRest();
        var showCenterButton = !sellIsAtRest || !buyIsAtRest;
        this.setState({
          showCenterButton: showCenterButton
        });
      }
    }
  }, {
    key: "onGroupingChange",
    value: function onGroupingChange(grouping) {
      (0, _priceGroupingHelper.storeGrouping)(this.props.selectedInstrumentId, grouping);
      this.setState({
        grouping: grouping
      });
    }
  }, {
    key: "setViewMode",
    value: function setViewMode(mode) {
      localStorage.setItem('orderBookViewMode', mode);
      if (mode === 'buy') {
        this.sellScroller.current = null;
      } else if (mode === 'sell') {
        this.buyScroller.current = null;
      }
      this.setState({
        viewMode: mode
      });
    }
  }, {
    key: "calculateAccumulatedSum",
    value: function calculateAccumulatedSum(data) {
      var reverseOrder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      if (!data || data.length === 0) return data;

      // For sell orders, we want to accumulate from best ask (lowest price) outward
      // If data is in reverse order (highest to lowest), we need to reverse it first
      var processData = reverseOrder ? _toConsumableArray(data).reverse() : data;
      var accumulatedSum = 0;
      var result = processData.map(function (item) {
        accumulatedSum += parseFloat(item.Quantity || 0);
        return _objectSpread(_objectSpread({}, item), {}, {
          AccumulatedSum: accumulatedSum
        });
      });

      // If we reversed for processing, reverse back to maintain original order
      return reverseOrder ? result.reverse() : result;
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        t = _this$props.t,
        cancelAllOrders = _this$props.cancelAllOrders,
        cancelBuyOrders = _this$props.cancelBuyOrders,
        cancelSellOrders = _this$props.cancelSellOrders,
        openOrders = _this$props.openOrders,
        buyOpenOrders = _this$props.buyOpenOrders,
        sellOpenOrders = _this$props.sellOpenOrders,
        selectedInstrument = _this$props.selectedInstrument,
        cancelOrders = _this$props.cancelOrders,
        _this$props$level = _this$props.level2,
        _this$props$level2 = _this$props$level === void 0 ? {
          buy: [],
          sell: []
        } : _this$props$level,
        buy = _this$props$level2.buy,
        sell = _this$props$level2.sell,
        buyPriceClicked = _this$props.buyPriceClicked,
        buyQuantityClicked = _this$props.buyQuantityClicked,
        sellPriceClicked = _this$props.sellPriceClicked,
        sellQuantityClicked = _this$props.sellQuantityClicked,
        fetching = _this$props.fetching,
        _this$props$hideBulkC = _this$props.hideBulkCancelButtons,
        hideBulkCancelButtons = _this$props$hideBulkC === void 0 ? false : _this$props$hideBulkC,
        _this$props$showAccum = _this$props.showAccumulatedSum,
        showAccumulatedSum = _this$props$showAccum === void 0 ? false : _this$props$showAccum,
        SpreadComponent = _this$props.SpreadComponent;
      var _this$state = this.state,
        viewMode = _this$state.viewMode,
        grouping = _this$state.grouping;
      var groupingOptions = this.getGroupingOptions();
      var groupedBuy = this.memoizedGroupLevel2Data('buy', buy, grouping);
      var groupedSell = this.memoizedGroupLevel2Data('sell', sell, grouping);
      var isGrouped = grouping && grouping !== _priceGroupingHelper.NONE_GROUPING_VALUE;
      var priceDecimalPlaces = (0, _decimalPlacesHelper.convertIncrementToIntDecimalPlaces)(Number(isGrouped ? grouping : selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.PriceIncrement));
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: tradeComponentClasses()
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: orderBookClasses('view-toggles')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: orderBookClasses('toggle-buttons')
      }, /*#__PURE__*/_react["default"].createElement("button", {
        title: t('Both Orders'),
        className: "".concat(orderBookClasses('toggle-button'), " ").concat(viewMode === 'both' ? 'active' : ''),
        onClick: function onClick() {
          return _this3.setViewMode('both');
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "orderbook-both"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        title: t('Buy Orders'),
        className: "".concat(orderBookClasses('toggle-button'), " ").concat(viewMode === 'buy' ? 'active' : ''),
        onClick: function onClick() {
          return _this3.setViewMode('buy');
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "orderbook-buy"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        title: t('Sell Orders'),
        className: "".concat(orderBookClasses('toggle-button'), " ").concat(viewMode === 'sell' ? 'active' : ''),
        onClick: function onClick() {
          return _this3.setViewMode('sell');
        }
      }, /*#__PURE__*/_react["default"].createElement(_APIcon["default"], {
        name: "orderbook-sell"
      }))), /*#__PURE__*/_react["default"].createElement(_PriceGroupingSelector["default"], {
        value: grouping,
        onChange: this.onGroupingChange,
        options: groupingOptions
      })), /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable(), " ").concat(orderBookClasses(), " view-mode--").concat(viewMode)
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('body'), " ").concat(orderBookClasses('body'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('header', 'background'), " ").concat(orderBookClasses('header'))
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: flexTable('column')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('fixed'), " ").concat(orderBookClasses('table-header', 'price'))
      }, t('Price'))), /*#__PURE__*/_react["default"].createElement("div", {
        className: flexTable('column')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('fixed'), " ").concat(orderBookClasses('table-header', 'qty'))
      }, t('Qty'))), showAccumulatedSum && /*#__PURE__*/_react["default"].createElement("div", {
        className: flexTable('column')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "".concat(flexTable('fixed'), " ").concat(orderBookClasses('table-header', 'sum'))
      }, t('Sum')))), /*#__PURE__*/_react["default"].createElement("div", {
        className: orderBookClasses('order-book-body')
      }, viewMode !== 'buy' && /*#__PURE__*/_react["default"].createElement(_APVerticalScroller["default"], {
        ref: this.sellScroller,
        restPosition: "bottom",
        onScrollRestChange: this.onScrollRestChange,
        customClass: orderBookClasses('vertical-scroller-body', (0, _browserHelper.isFirefox)() ? 'firefox' : '')
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "orderbook__table-filler"
      }, /*#__PURE__*/_react["default"].createElement(_Level2DataTableComponent["default"], {
        quantityDecimalPlaces: this.props.convertedQuantityIncrement,
        priceDecimalPlaces: priceDecimalPlaces,
        selectedInstrument: selectedInstrument,
        cancelOrders: cancelOrders,
        onPriceClick: sellPriceClicked,
        onQuantityClick: sellQuantityClicked,
        level2Data: showAccumulatedSum ? this.calculateAccumulatedSum(groupedSell, true) : groupedSell,
        classModifier: 'sell',
        fetching: fetching,
        showAccumulatedSum: showAccumulatedSum
      }))), viewMode === 'both' && !!SpreadComponent && /*#__PURE__*/_react["default"].createElement(SpreadComponent, {
        spread: this.props.spread,
        onCenterClick: function onCenterClick() {
          return _this3.onClickCenter(true);
        },
        showCenterButton: this.state.showCenterButton
      }), viewMode !== 'sell' && /*#__PURE__*/_react["default"].createElement(_APVerticalScroller["default"], {
        ref: this.buyScroller,
        restPosition: "top",
        onScrollRestChange: this.onScrollRestChange,
        customClass: orderBookClasses('vertical-scroller-body', (0, _browserHelper.isFirefox)() ? 'firefox' : '')
      }, /*#__PURE__*/_react["default"].createElement(_Level2DataTableComponent["default"], {
        quantityDecimalPlaces: this.props.convertedQuantityIncrement,
        priceDecimalPlaces: priceDecimalPlaces,
        selectedInstrument: selectedInstrument,
        cancelOrders: cancelOrders,
        onPriceClick: buyPriceClicked,
        onQuantityClick: buyQuantityClicked,
        level2Data: showAccumulatedSum ? this.calculateAccumulatedSum(groupedBuy) : groupedBuy,
        classModifier: 'buy',
        fetching: fetching,
        showAccumulatedSum: showAccumulatedSum
      })), !hideBulkCancelButtons && /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_BulkCancelButtonsComponent["default"], {
        openOrders: openOrders,
        buyOpenOrders: buyOpenOrders,
        sellOpenOrders: sellOpenOrders,
        cancelAllOrders: cancelAllOrders,
        cancelBuyOrders: cancelBuyOrders,
        cancelSellOrders: cancelSellOrders
      }))))));
    }
  }]);
}(_react["default"].Component);
var _default = exports["default"] = (0, _reactI18next.withTranslation)('order')(OrderBookComponent);